import { HUD } from '@/config/hud';
import { loadRecords, type RunStats } from '@/core/records';
import { t, type I18nKey } from '@/i18n';
import { sfx } from '@/audio/sfx';
import type { Hud } from './hud';

/**
 * In-run record toast: the moment a lifetime best is beaten, flash a
 * one-time "★ <metric>" notice (only when a previous record exists).
 */
export class RecordToasts {
  /** Records at run start + per-metric "beaten" flags */
  private base: Partial<RunStats> = loadRecords();
  private readonly toasted = new Set<keyof RunStats>();

  constructor(private readonly hud: Hud) {}

  /** Re-read the bests (new run / after a death rebuild). */
  reset(): void {
    this.base = loadRecords();
    this.toasted.clear();
  }

  check(stats: RunStats): void {
    for (const key of HUD.recordToastMetrics) {
      const base = this.base[key] ?? 0;
      if (base > 0 && stats[key] > base && !this.toasted.has(key)) {
        this.toasted.add(key);
        sfx.recordToast();
        this.hud.notify(`★ ${t(`stats.${key}` as I18nKey)}!`, 'record');
      }
    }
  }
}
